import { Pagination } from 'antd';

import './DefaultPagination.scss';

const navArrowContClass = 'rounded-3xl bg-white w-[28px] h-[28px] flex justify-center items-center';

function DefaultPagination({
  onChange, totalItems, currentPage, pageSize,
}) {
  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return (
        <div className={navArrowContClass}>
          <div className="arrow rotate-[135deg] ml-1 !border-black" />
        </div>
      );
    }
    if (type === 'next') {
      return (
        <div className={navArrowContClass}>
          <div className="arrow rotate-[-45deg] mr-1 !border-black" />
        </div>
      );
    }
    return originalElement;
  };

  return (
    <Pagination
      className="default-pagination"
      itemRender={itemRender}
      onChange={onChange}
      total={totalItems}
      current={currentPage}
      pageSize={pageSize}
      showSizeChanger={false}
    />
  );
}

export default DefaultPagination;
